<!--  預約 container-->
<div class="reserve-container" 
     [ngClass]="{
       'special-health-plan': isSpecialHealthPlan,
       'reserve-loading-page': isLoadingPage
     }">
  @if (reserveStep !== 2.5 && reserveStep <= 8 && !isCompletePage && healthPlan !== 'special') {
    <!--  預約:共用步驟列 -->
    <div class="reserve-steps">
      @if (reserveStep <= 5) {
        <div
          class="reserve-steps-block"
          [ngClass]="{ 'active-step': reserveStep >= 1 }"
        >
          <span class="reserve-steps-process"></span>
          <p class="reserve-steps-title">
            {{ 'reserve.select-location' | translate }}
          </p>
        </div>
        <div
          class="reserve-steps-block"
          [ngClass]="{ 'active-step': reserveStep >= 2 }"
        >
          <span class="reserve-steps-process"></span>
          <p class="reserve-steps-title">
            {{ 'reserve.fill-information' | translate }}
          </p>
        </div>
        <div
          class="reserve-steps-block"
          [ngClass]="{ 'active-step': reserveStep >= 3 }"
        >
          <span class="reserve-steps-process"></span>
          <p class="reserve-steps-title">
            {{ 'reserve.select-plan' | translate }}
          </p>
        </div>
        <div
          class="reserve-steps-block"
          [ngClass]="{ 'active-step': reserveStep >= 4 }"
        >
          <span class="reserve-steps-process"></span>
          <p class="reserve-steps-title">
            {{ 'reserve.add-item' | translate }}
          </p>
        </div>
        <div
          class="reserve-steps-block"
          [ngClass]="{ 'active-step': reserveStep >= 5 }"
        >
          <span class="reserve-steps-process"></span>
          <p class="reserve-steps-title">
            {{ 'reserve.confirm-content' | translate }}
          </p>
        </div>
      } @else {
        <div
          class="reserve-steps-block"
          [ngClass]="{ 'active-step': reserveStep >= 6 }"
        >
          <span class="reserve-steps-process"></span>
          <p class="reserve-steps-title">
            {{ 'reserve.exam-info' | translate }}
          </p>
        </div>
        <div
          class="reserve-steps-block"
          [ngClass]="{ 'active-step': reserveStep >= 7 }"
        >
          <span class="reserve-steps-process"></span>
          <p class="reserve-steps-title">
            {{ 'reserve.select-date' | translate }}
          </p>
        </div>
        <div
          class="reserve-steps-block"
          [ngClass]="{ 'active-step': reserveStep >= 8 }"
        >
          <span class="reserve-steps-process"></span>
          <p class="reserve-steps-title">
            {{ 'reserve.confirm-info' | translate }}
          </p>
        </div>
      }
    </div>
  }
  <div class="reserve-page-content">
    <router-outlet></router-outlet>
  </div>
</div>
